import { render, staticRenderFns } from "./SupplierAccountSummaryView.vue?vue&type=template&id=5ecf5896"
import script from "./SupplierAccountSummaryView.vue?vue&type=script&lang=js"
export * from "./SupplierAccountSummaryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports